export default __webpack_public_path__ + "6a4c94b96f9c1d8d87c11b3b31658192.svg";